export default {
  props: [
    {
      attr: 'teacherName',
      name: '老师名称'
    },
    {
      attr: 'email',
      name: '邮箱',
      slot: 'email'
    },
    {
      attr: 'orgName',
      name: '所属校区'
    },
    {
      attr: 'layer',
      name: '老师等级'
    },
    {
      attr: 'sex',
      name: '性别'
    },
    {
      attr: 'status',
      name: '老师状态',
      slot: 'status'
    }
  ]
}
